import React from "react";

export const LicenseSlide = React.lazy(() => import("./LicenseSlide"));
export const MindMapSlide = React.lazy(() => import("./MindMapSlide"));
export const SignUpSlide = React.lazy(() => import("./SignUpSlide"));
export const AgreementSlide = React.lazy(() => import("./AgreementSlide"));
